import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React from 'react';

/**
 * @param {object} props
 * @param {object} props.blok
 */
const StoryblokCarouselPartnerSlide = ({ blok }) => {
  const { partner } = blok;

  const hasPartner = partner && partner.length > 0;
  if (!hasPartner) return null;

  return (
    <Box {...storyblokEditable(blok)} key={blok._uid}>
      <StoryblokComponent blok={partner[0]} key={partner[0]._uid} />
    </Box>
  );
};

export default StoryblokCarouselPartnerSlide;
